module.exports = __webpack_public_path__ + "../static/img/base_city.56c2b467.png";